import gpay from "../assets/images/gpay.svg";
import paytm from "../assets/images/paytm.svg";
import phonepe from "../assets/images/phonepe.svg";

const upiApplications = [
  {
    name: "Google pay",
    key: "gpay",
    path: gpay,
  },
  {
    name: "Paytm",
    key: "paytm",
    path: paytm,
  },
  {
    name: "Phonepe",
    key: "phonepe",
    path: phonepe,
  },
];

export default upiApplications;
